import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetMarkets,
  MarketCreators,
  resetMarketDetail,
} from "redux/modules/market";

function useMarket() {
  const dispatch = useDispatch();

  const fetchMarkets = useCallback(
    ({ market, sort, page }) => {
      dispatch(MarketCreators.fetchMarkets({ market, sort, page }));
    },
    [dispatch]
  );

  const resetMarketItems = useCallback(() => {
    dispatch(resetMarkets());
  }, [dispatch]);


  const resetMarketDetailItem = useCallback(() => {
    dispatch(resetMarketDetail());
  }, [dispatch]);

  const fetchLikeList = useCallback(
    ({ userId, page }) => {
      dispatch(MarketCreators.fetchLikeList({ userId, page }));
    },
    [dispatch]
  );

  const likeMarket = useCallback(
    ({ wholeId }) => {
      dispatch(MarketCreators.likeMarket({ wholeId }));
    },
    [dispatch]
  );

  const unlikeMarket = useCallback(
    ({ wholeId }) => {
      dispatch(MarketCreators.unlikeMarket({ wholeId }));
    },
    [dispatch]
  );

  const fetchMarketDetail = useCallback(
    ({ wholeId }) => {
      dispatch(MarketCreators.fetchMarketDetail({ wholeId }));
    },
    [dispatch]
  );

  const fetchSimilarMarkets = useCallback(
    ({ wholeId }) => {
      dispatch(MarketCreators.fetchSimilarMarkets(wholeId));
    },
    [dispatch]
  );

  const marketState = useSelector((state) => ({
    markets: state.market.markets,
    totalMarketsCount: state.market.totalMarketsCount,
    likeMarketRes: state.market.likeMarketRes,
    marketDetail: state.market.marketDetail,
    similarMarkets: state.market.similarMarkets,
    likeList: state.market.likeList,
  }));

  const {
    markets,
    totalMarketsCount,
    likeMarketRes,
    marketDetail,
    similarMarkets,
    likeList,
  } = marketState;

  return {
    markets,
    totalMarketsCount,
    likeMarketRes,
    marketDetail,
    similarMarkets,
    likeList,
    fetchMarkets,
    resetMarketItems,
    resetMarketDetailItem,
    fetchLikeList,
    likeMarket,
    unlikeMarket,
    fetchMarketDetail,
    fetchSimilarMarkets,
  };
}

export default useMarket;
